import { useEffect, useRef } from "react";
import { useCommands } from "@components/commands/useCommands";

interface UseTaskBulkActionsOpenOverrideParams {
    selectedCount: number;
    openBulkActions: () => void;
}

/** While tasks are selected, Cmd+K opens their bulk actions palette. */
export function useTaskBulkActionsOpenOverride({
    selectedCount,
    openBulkActions,
}: UseTaskBulkActionsOpenOverrideParams) {
    const { registerOpenOverride, unregisterOpenOverride } = useCommands();
    const openBulkActionsRef = useRef(openBulkActions);
    openBulkActionsRef.current = openBulkActions;

    useEffect(() => {
        if (selectedCount > 0) {
            registerOpenOverride(() => openBulkActionsRef.current());
            return () => unregisterOpenOverride();
        }
        unregisterOpenOverride();
    }, [selectedCount, registerOpenOverride, unregisterOpenOverride]);
}
